import React, { useMemo } from 'react';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const MediaGalleryOverlay = ({
    product,
    resources
}: {
    product?: SimpleProduct;
    resources: {
        usedProductImageOverlayText: string;
    };
}) => {
    const isUsedSku = useMemo(() => !!product?.ExtensionProperties?.find(ep => ep.Key === 'NewSku')?.Value?.StringValue, [product]);

    if (!isUsedSku) {
        return null;
    }

    return (
        <div className='used-product-overlay-container'>
            <div className='used-product-overlay-text'>{resources.usedProductImageOverlayText}</div>
        </div>
    );
};

export { MediaGalleryOverlay };
